import React from 'react';

const RolesPage = () => {
  return (
    <div className="card">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <h3>User Roles & Permissions</h3>
        <button className="secondary">Add Role</button>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>Role</th>
            <th>Access</th>
            <th>Users</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>Admin</td><td>Full</td><td>4</td><td><button className="secondary">Edit</button></td></tr>
          <tr><td>Ops</td><td>Orders, Inventory</td><td>6</td><td><button className="secondary">Edit</button></td></tr>
        </tbody>
      </table>
    </div>
  );
};

export default RolesPage;
